module.exports = __webpack_public_path__ + "img/DNADamage-CRC_10X_TGSP.c87cf165.png";